/* eslint-disable */
import { securedAxiosAPI } from 'utils/axios';

const base = '/invoice/reports';

export const getDetailedInvoiceReport = async ({ page_number = 1, page_size = 25, fromDate, toDate, customerIds, invoiceNumber }) => {
    const q = new URLSearchParams();
    q.append('page_number', page_number);
    q.append('page_size', page_size);
    if (fromDate) q.append('fromDate', fromDate);
    if (toDate) q.append('toDate', toDate);
    if (customerIds) q.append('customerIds', customerIds);
    if (invoiceNumber) q.append('invoiceNumber', invoiceNumber);

    const url = `${base}/detailed?${q.toString()}`;
    const res = await securedAxiosAPI.get(url);
    return res.data;
};

export const getUninvoicedReport = async ({ page_number = 1, page_size = 25, fromDate, toDate, customerIds, analysisIds, testTypeIds }) => {
    const q = new URLSearchParams();
    q.append('page_number', page_number);
    q.append('page_size', page_size);
    if (fromDate) q.append('fromDate', fromDate);
    if (toDate) q.append('toDate', toDate);
    if (customerIds) q.append('customerIds', customerIds);
    if (analysisIds) q.append('analysisIds', Array.isArray(analysisIds) ? analysisIds.join(',') : analysisIds);
    if (testTypeIds) q.append('testTypeIds', Array.isArray(testTypeIds) ? testTypeIds.join(',') : testTypeIds);

    const url = `${base}/uninvoiced?${q.toString()}`;
    const res = await securedAxiosAPI.get(url);
    return res.data;
};

export default {
    getDetailedInvoiceReport,
    getUninvoicedReport
};

export const downloadDetailedReportExcel = async ({
    page_number = 1,
    page_size = 25,
    fromDate,
    toDate,
    customerIds,
    invoiceNumber
} = {}) => {
    const q = new URLSearchParams();
    q.append('page_number', page_number);
    q.append('page_size', page_size);
    if (fromDate) q.append('fromDate', fromDate);
    if (toDate) q.append('toDate', toDate);
    if (customerIds) q.append('customerIds', customerIds);
    if (invoiceNumber) q.append('invoiceNumber', invoiceNumber);
    q.append('downloadExcel', 'true');

    const url = `${base}/detailed?${q.toString()}`;
    const res = await securedAxiosAPI.get(url, { responseType: 'blob' });
    const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    const fileName = `detailed_invoice_report_${Date.now()}.xlsx`;
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(link.href);
};

export const downloadUninvoicedReportExcel = async ({
    page_number = 1,
    page_size = 25,
    fromDate,
    toDate,
    customerIds,
    analysisIds,
    testTypeIds
} = {}) => {
    const q = new URLSearchParams();
    q.append('page_number', page_number);
    q.append('page_size', page_size);
    if (fromDate) q.append('fromDate', fromDate);
    if (toDate) q.append('toDate', toDate);
    if (customerIds) q.append('customerIds', customerIds);
    if (analysisIds) q.append('analysisIds', Array.isArray(analysisIds) ? analysisIds.join(',') : analysisIds);
    if (testTypeIds) q.append('testTypeIds', Array.isArray(testTypeIds) ? testTypeIds.join(',') : testTypeIds);
    q.append('downloadExcel', 'true');

    const url = `${base}/uninvoiced?${q.toString()}`;
    const res = await securedAxiosAPI.get(url, { responseType: 'blob' });
    const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    const fileName = `uninvoiced_report_${Date.now()}.xlsx`;
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(link.href);
};
